<template>
  <div>
    <Row type="flex" justify="center">
      <Col>
        <h3
          style="color:#893448;font-size:18px;letter-spacing:0.4px;white-space: nowrap;"
        >{{ table_title }}</h3>
      </Col>
    </Row>
    <Row>
      <Col offset="20" span="4">
        <Drawer
          v-model="if_model_open"
          :closable="false"
          width="350"
        >
          <div class="demo-drawer-hearde">
            <Row type="flex" justify="center">
              <h2>设置参数</h2>
            </Row>
          </div>
          <Row style="height:20px;"></Row>
          <div class="demo-drawer-footer">
            <Row type="flex" justify="start">
              <Form label-position="left" :label-width="120" :label-colon="true">
                <FormItem label="查询起始时间点">
                  <DatePicker
                    :options=options1
                    size="small"
                    type="date"
                    format="yyyy-MM-dd"
                    v-model="start_datetime"
                    placeholder="选择日期"
                  ></DatePicker>
                </FormItem>
                <FormItem label="查询末尾时间点">
                  <DatePicker
                    :options=options1
                    size="small"
                    type="date"
                    format="yyyy-MM-dd"
                    v-model="end_datetime"
                    placeholder="选择日期"
                  ></DatePicker>
                </FormItem>
              </Form>
            </Row>
            <Row type="flex" justify="center">
              <Button type="primary" @click="drawer_click_submit">确定</Button>
              <Button style="margin-left: 20px" @click="if_model_open = false">取消</Button>
            </Row>
          </div>
        </Drawer>
      </Col>
    </Row>
    <Row type="flex" justify="center" align="middle">
      <Col :offset="22" :span="1">
        <Button ref="drawer_button" style="border:0" 
          @click="click_drawer" size="large" icon="ios-settings"></Button>
          <!-- <img src="../assets/imgs/setting.svg"> -->
      </Col>
      <Col  :span="1">
        <Button
          shape="circle"
          icon="md-download"
          @click="export_transaction_record_table_data"
        ></Button>
      </Col>
    </Row>
    <Row>
      <v-table
        :title="this.binance_income_record_title"
        :title_info="this.binance_income_record_info"
        :table_columns="this.binance_income_record_table_columns"
        :table_data="this.binance_income_record_table_data"
        :ref="this.binance_income_record_ref"
        :max_height="700"
        :init_table="this.binance_income_record_init_table_func"
        :table_name_array="this.binance_income_name_array"
        :show_top="false"
        :table_page_size="100"
      ></v-table>
    </Row>
  </div>
</template>

<script>
import {
  array_to_object
} from "../utils";
import table_view from "../components/TableView.vue";

export default {
  name: "tools_income_supervisor",
  components: {
    "v-table": table_view
  },
  data() {
    return {
      timer: null,
      table_title: "BinanceAPI流水汇总",
      if_model_open: false,
      end_datetime: new Date(),
      start_datetime: this.get_cycle_start(),
      binance_income_record_title: "",
      binance_income_record_info: [],
      binance_income_record_table_columns: [],
      binance_income_record_table_data: [],
      binance_income_record_ref: "binance_income_record_ref",
      binance_income_name_array: [
        "账户信息",
        "账户说明",
        "邮箱",
        "返佣数(USDT)",
        "返佣条目数",
      ],
      options1: {
          shortcuts: [
              {
                  text: '今天',
                  value () {
                      var date = new Date();
                      date.setHours(0)
                      date.setMinutes(0)
                      date.setSeconds(0)
                      date.setMilliseconds(0)
                      return date
                  },
              },
              {
                  text: '上个月9号',
                  value () {
                      var date = new Date();
                      var month = date.getMonth() + 1
                      var day = date.getDate()
                      if (day > 9) {
                        date.setDate(9)
                      } else {
                        date.setMonth(month - 1)
                        date.setDate(9)
                      }
                      date.setHours(0)
                      date.setMinutes(0)
                      date.setSeconds(0)
                      date.setMilliseconds(0)
                      return date
                  }
              },
              {
                  text: '一月前',
                  value () {
                      const date = new Date();
                      date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
                      return date;
                  }
              },
              {
                  text: '设定起始点',
                  value () {
                      const date = new Date(2020, 1, 0);
                      date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
                      return date;
                  }
              }
          ]
      },
    };
  },
  methods: {
    get_cycle_start () {
      // 获得周期起点的日期
      // 币安是9号为起始周期
      var date = new Date();
      var month = date.getMonth() + 1
      var day = date.getDate()
      if (day > 9) {
        date.setDate(9)
      } else {
        date.setMonth(month - 2)
        date.setDate(9)
      }
      date.setHours(0)
      date.setMinutes(0)
      date.setSeconds(0)
      date.setMilliseconds(0)
      return date
    },
    setTimer: function(interval) {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.load_tables_data(Date.parse(new Date()))
        }, interval);
      }
    },
    drawer_click_submit: function() {
      this.load_tables_data()
      this.if_model_open = false;
    },
    click_drawer: function() {
      this.if_model_open = true;
    },
    load_tables_data: async function() {
      let _start_timestamp = Date.parse(this.start_datetime)
      let _end_timestamp = Date.parse(this.end_datetime)
      let binance_income_record_data = await this.$axios.get(
        this.$store.state.urlPort + "/load_tools_data",
        {
          params: {
            mode: "income_supervisor",
            which_web_need: this.account_id,
            start_datetime: _start_timestamp,
            end_datetime: _end_timestamp,
          }
        }
      );
      this.set_binance_income_record_data(binance_income_record_data);
    },
    binance_income_record_init_table_func: function() {
      const name_array = this.binance_income_name_array;
      this.binance_income_record_table_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.binance_income_record_table_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }

      this.binance_income_record_table_columns[0]["minWidth"] = 155;
      this.binance_income_record_table_columns[1]["minWidth"] = 155;
      this.binance_income_record_table_columns[2]["minWidth"] = 155;
      this.binance_income_record_table_columns[3]["minWidth"] = 155;
      this.binance_income_record_table_columns[4]["minWidth"] = 155;
      
      this.binance_income_record_table_columns[1]["tooltip"] = true;
      this.binance_income_record_table_columns[2]["tooltip"] = true;
      
    },
    set_binance_income_record_data: function(data) {
      this.binance_income_record_title = data["name"];
      this.binance_income_record_table_data = []
      for (var i = 0; i < data["data"].length; i++) {
        this.binance_income_record_table_data.push(data["data"][i])
      }

      this.binance_income_record_info = [
        { name: "总计数量 ", value: this.binance_income_record_table_data.length },
      ];

    },
    export_transaction_record_table_data: function() {
      this.$refs.binance_income_record_ref.$children[0].$children[0].exportCsv({
        filename: "binance_income_record_ref", //导出Excel的文件名
        data: array_to_object(
          this.binance_income_name_array,
          this.binance_income_record_table_data
        ),
        columns: this.binance_income_record_table_columns
      });
    },
  },
  mounted() {
    this.account_id = this.$route.path.split("=")[1];
    this.load_tables_data()
  },
  created: function() {
    clearInterval(this.timer);
    this.timer = null;
    // 5分钟一刷新
    this.setTimer(5 * 60 * 1000);
  },
  destroyed() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<style scoped>
.header-collapse {
  background-color: rgba(255, 255, 255, 0.2);
}
.panel-name {
  display: flex;
  font-size: 18px;
  color: #2b85e4;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
.panel-content {
  font-size: 15px;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
</style>